import { isCurie } from '../hub/curie.js';
/**
 * A {@link CalmReferenceResolver} that resolves references by loading raw documents through a
 * {@link SchemaDirectory}.
 *
 * This bridges the `SchemaDirectory.loadDocument(id, type)` seam to the plain `canResolve`/`resolve`
 * resolver interface, so validation can share the same resolver abstraction (and the
 * {@link import('./caching-tracking-resolver').CachingTrackingResolver} decorator) as the model
 * dereference path — rather than passing a bespoke loader lambda.
 */
export class SchemaDirectoryReferenceResolver {
    constructor(schemaDirectory, documentType = 'architecture') {
        this.schemaDirectory = schemaDirectory;
        this.documentType = documentType;
    }
    canResolve(reference) {
        if (isCurie(reference))
            return false;
        return this.schemaDirectory !== undefined;
    }
    async resolve(reference) {
        if (!this.schemaDirectory) {
            throw new Error(`Cannot resolve reference '${reference}' without a schema directory`);
        }
        return this.schemaDirectory.loadDocument(reference, this.documentType);
    }
}
//# sourceMappingURL=schema-directory-reference-resolver.js.map